import React from 'react'
import { Box } from '@mui/material'
import { usePricing } from '@api/pricing'
import { useTranslation } from 'next-i18next'
import { groupBy } from 'lodash'
import RegularNarrow from './RegularNarrow'
import RegularWide from './RegularWide'

function Regular() {
  const { i18n } = useTranslation()
  const pricingQuery = usePricing(i18n.language)
  const features = groupBy(pricingQuery.data?.features ?? [], 'section')
  const featurePlans = Object.entries(features).map(([key, items]) => ({
    title: key,
    features: items,
  }))
  return (
    <Box>
      <Box sx={{ display: { xs: 'none', md: 'block' }, position: 'relative' }}>
        <RegularWide
          plans={pricingQuery?.data?.plans ?? []}
          featurePlans={featurePlans}
        />
      </Box>
      <Box sx={{ display: { xs: 'block', md: 'none' }, position: 'relative' }}>
        <RegularNarrow
          plans={pricingQuery?.data?.plans ?? []}
          featurePlans={featurePlans}
        />
      </Box>
    </Box>
  )
}

export default Regular
